/* DataTables plugins
* copied from src/static_src/js/c2Archive/datatable_plugins.js
* Skipped Plugins: $.fn.dataTableExt.oPagination - 4-button pagination control with Bootstrap style icons
* fnSetFilteringDelay - Add a delay to the firing of DataTables search box.
*/

DataTable.Api.register('countSelectedRows()', function () {
  var byData = this.settings()[0].oLoadedState?.customRows;
  var byCount = this.rows({ selected: true }).count();

  return byData?.length || byCount;
});

DataTable.Api.register('saveSelectedRows()', function () {
  // Save selected rows to the state object
  var $rowsSelected = this.rows( { selected: true } ).data();
  var $rowsUnselected = this.rows( { selected: false } ).data();

  var values = _.map($rowsSelected, function(cells) { return $(cells[0]).val()});
  var valuesNotSelected = _.map($rowsUnselected, function(cells) { return $(cells[0]).val()});
  var valuesOld = this.settings()[0].oLoadedState?.customRows || []

  values = _.union(values, valuesOld);
  values = _.difference(values, valuesNotSelected);

  if (!this.settings()[0].oLoadedState) {
    this.settings()[0].oLoadedState = {};
  }
  this.settings()[0].oLoadedState.customRows = _.uniq(values);
});

DataTable.Api.register('restoreSelectedRows()', function () {
  // Load selected rows from the state object
  var $input
  var values = this.settings()[0].oLoadedState?.customRows;

  this.rows().every(function () {
      var rowData = this.data();
      var checkInput = $(rowData[0]).val()
      if (values?.includes(checkInput)) {
        this.select();
      }
  });
  this.fnUpdateSelectionInfo();
});


DataTable.Api.register('isServerSide()', function () {
  var settings = this.settings()[0];
  return Boolean(settings.features.serverSide);
});


// DataTables plugin to unselect all rows via the Select extension.
DataTable.Api.register('clearSelection()', function () {
  var savedRows = this.settings()[0].oLoadedState?.customRows;
  if (savedRows) {
    this.settings()[0].oLoadedState.customRows = [];
  }
  this.rows({ selected: true }).deselect();
  c2.forms.updateBatchCheckboxes($(this.table().node()));

  // refresh the badge
  this.fnUpdateSelectionInfo();

  return this;
});


DataTable.Api.register('isSingleSelect()', function () {
  // this.context[0] is undefined when the Api matched no initialized table
  // (e.g. a selector for a table that no longer exists). Treat "can't tell"
  // as "not single-select", which is the correct default for the vast
  // majority of tables anyway.
  var select = this.context[0] && this.context[0]._select;
  return !!select && select.style === 'single';
});


/* For tables whose rows may be selected by the user, update the number of
 * selected rows in an informational area. This counts selections across all
 * rows, not just visible rows.
 */
DataTable.Api.register('fnUpdateSelectionInfo()', function () {
  if (this.isSingleSelect()) {
    return;
  }

  var numSelected = this.countSelectedRows();
  var $wrap = $(this.table().node()).closest('.dt-container');
  var $toolbar = $wrap.find('.dt-buttons');
  var $info = $wrap.find('.selection-info');
  if ($info.length === 0) {
    return;
  }

  var $actionButtons = $toolbar.find('.selection-action');
  if (numSelected > 0) {
    $info.addClass('active-selection');
    $actionButtons.removeClass('disabled');
  } else {
    $info.removeClass('active-selection');
    $actionButtons.addClass('disabled');
  }

  $wrap.find('.selection-info .selection-count').html(numSelected);
});
